var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-elements" }, [
    _c("dl", [
      _c(
        "dt",
        {
          staticClass: "collapsed",
          attrs: {
            "data-toggle": "collapse",
            "data-target": "#go-channel-content-" + _vm.state.instanceId,
            "aria-expanded": "false",
          },
        },
        [
          _c("div", { staticClass: "go-panel-header" }, [
            _c("ul", [
              _c("li", [
                _c("div", { staticClass: "go-channel-img" }, [
                  _c("img", {
                    attrs: {
                      src: _vm.accountChannel.channelImageUri,
                      alt: _vm.accountChannel.channelNameEn,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "go-channel-info" }, [
                  _c("small", [
                    _vm._v(_vm._s(_vm.accountChannel.channelNameEn)),
                  ]),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.accountChannel.accountName ||
                          _vm.accountChannel.fullname
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.accountChannel.accountId &&
                  !_vm.accountChannel.isAliveAccount
                    ? _c("p", { staticClass: "go-channel-msg" }, [
                        _c("i", {
                          staticClass: "go-icon-20 go-icon-alert-circle-filled",
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "my-collection-channel.account.expire-warning"
                              )
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "dd",
        {
          staticClass: "collapse",
          attrs: { id: "go-channel-content-" + _vm.state.instanceId },
        },
        [
          _c("div", { staticClass: "go-panel-body" }, [
            _c(
              "ul",
              _vm._l(_vm.accountChannel.collections, function (agent, index) {
                return _c("li", { key: index }, [
                  _c("div", { staticClass: "go-channel-access" }, [
                    _c("div", { staticClass: "go-channel-detail" }, [
                      _c(
                        "ol",
                        [
                          _vm._l(
                            agent.datasourceList,
                            function (field, dIndex) {
                              return [
                                field.dataSourceAccStatus
                                  ? _c("li", { key: dIndex }, [
                                      _c(
                                        "span",
                                        [
                                          _vm._v(
                                            _vm._s(field.descriptionEn) +
                                              "\n                        "
                                          ),
                                          field.datasourceValue
                                            ? [_vm._v(":")]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.valueDataSource(
                                              field.datasourceValue
                                            )
                                          ) +
                                          "\n                    "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "go-channel-detail-btns" }, [
                      _c("div", { staticClass: "go-channel-btn" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn go-btn-icon",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.updateAgent(agent)
                              },
                            },
                          },
                          [_c("i", { staticClass: "go-icon-20 go-icon-edit" })]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-channel-link" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.navigate2Bp(agent.bpId)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "go-icon-16 go-icon-browser-share",
                        }),
                        _vm._v(" "),
                        _c("em", { staticClass: "go-text" }, [
                          _vm._v(" " + _vm._s(agent.bpName) + " "),
                        ]),
                      ]
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", { staticClass: "go-channel-collapse" }, [
        _c("span", { staticClass: "go-toggle-off" }),
        _vm._v(" "),
        _c("span", { staticClass: "go-toggle-on" }),
        _vm._v(" "),
        _c("i", { staticClass: "go-icon-22 go-icon-chevron-up" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }